import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-overlays/Modal';
import { defineMessages, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './Lightbox.scss';
import CloseIcon from '../../components/icons/Close';
import { detectActivationEvent, customisedIntlFormatMessage } from '../../utils/helpers';

// const rand = () => Math.floor(Math.random() * 20) - 10;

const backdropStyle = {
  position: 'fixed',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 'auto',
  backgroundColor: '#f6f6f6',
  opacity: 0.85,
};

const localMessages = defineMessages({
  lightboxCloseModal: {
    id: 'lightbox.closeModal',
    defaultMessage: `Close Modal`,
    description: 'aria label for button to close modal',
  },
});

class Lightbox extends Component {
  static defaultProps = {
    children: null,
    dialog: '',
    ariaLabel: '',
  };

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    dialog: PropTypes.string,
    close: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
    showModal: PropTypes.bool.isRequired,
    intl: PropTypes.shape().isRequired,
  };

  constructor(props) {
    super(props);
    // create a ref to store the textInput DOM element
    this.lightBoxCloseButton = React.createRef();
    this.lightBoxFocus = this.lightBoxFocus.bind(this);
  }

  lightBoxFocus = () => {
    // Explicitly focus the button using the raw DOM API
    // Note: we're accessing "current" to get the DOM node
    this.lightBoxCloseButton.current.focus();
  };

  handleOnKeydown = event => {
    const { close } = this.props;
    if (detectActivationEvent(event)) {
      close();
    }
  };

  render() {
    const { close, showModal, dialog, children, ariaLabel, intl } = this.props;
    return (
      <div>
        <Modal
          aria-label={ariaLabel}
          className={style.modal}
          backdropstyle={backdropStyle}
          show={showModal}
          // onHide={this.close}
          // container={this}
          onShow={this.lightBoxFocus}
        >
          <div className={style.dialog}>
            {dialog}
            {children}
            <button
              className={style.buttonWrapper}
              onClick={close}
              onKeyDown={this.handleOnKeydown}
              aria-label={customisedIntlFormatMessage(intl, localMessages.lightboxCloseModal)}
              ref={this.lightBoxCloseButton}
            >
              <CloseIcon size={24} fill="#024cbc" />
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default injectIntl(withStyles(style)(Lightbox));
